import * as React from "react";
import { mk_widget, option, Options, Widget } from "../widget";

/** @deprecated Use [[wrapHTML]] instead. */
export const dangerous_inline_html = function<o>(html:string, options?:Options) : Widget<o> {
  return mk_widget({
    run:(on_done:(output:o) => void) =>
      <div  id={option("id", options)}
        className={options ? options.className : undefined}
        style={options ? options.style : undefined}
        key={options ? options.key : undefined}
        dangerouslySetInnerHTML={{ __html:html }} >
      </div>
  })
}
